"use client";

import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { NativeLink } from "@/components/native-link";
import { PageHeader } from "@/components/pulse-shell";
import { USERS_LOCAL_NAV, usersNavActive } from "@/lib/users-nav";
import { Shield, Users } from "lucide-react";

const LOCAL_NAV = USERS_LOCAL_NAV.map((item) => ({
  ...item,
  icon: item.href === "/users/all" ? Users : Shield,
}));

export function UsersLayout({
  children,
  actions,
}: {
  children: ReactNode;
  actions?: ReactNode;
}) {
  const { pathname } = useLocation();
  return (
    <>
      <PageHeader
        title="Users"
        subtitle="Manage workspace members, roles, and access."
        actions={actions}
      />
      <div className="users-layout">
        <aside className="card users-local-nav" aria-label="Users sections">
          {LOCAL_NAV.map(({ href, label, icon: Icon }) => {
            const active = usersNavActive(href, pathname);
            return (
              <NativeLink
                key={href}
                href={href}
                className={`users-local-nav-item ${active ? "active" : ""}`}
              >
                <Icon size={18} />
                <span>{label}</span>
              </NativeLink>
            );
          })}
        </aside>
        <div className="users-main">{children}</div>
      </div>
    </>
  );
}
